export default {
  financial_data_from: "Financial data from"
}